module.exports = __webpack_public_path__ + "static/img/no_partner.5bd25cd5.svg";